import { Component} from '@angular/core';
import {DialogAdapter, DialogParams} from '../../models/dialog-param';
import {EVENT_RECURSIVE_OPTIONS} from '../../common/constants';

@Component({
  selector: 'app-modal-action-buttons',
  templateUrl: './modal-action-buttons.component.html',
  styleUrls: ['./modal-action-buttons.component.scss'],
  preserveWhitespaces: false
})
export class ModalActionButtonsComponent implements DialogAdapter {
  params: DialogParams;
  prop: any;
  event_recursive_options: typeof EVENT_RECURSIVE_OPTIONS = EVENT_RECURSIVE_OPTIONS;
  recursive_option: EVENT_RECURSIVE_OPTIONS;

  constructor() { }

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
  }

  getPayload(): any {
    return {recursive_option: this.recursive_option};
  }

  clickBtn(value: any) {
    this.recursive_option = value;
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/modal-action-buttons/modal-action-buttons.component.ts